import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCog12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCog12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Cog12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M5.625 0a1.5 1.5 0 0 0-1.5 1.461l-.009.004a1.5 1.5 0 0 0-2.093.027l-.53.53a1.5 1.5 0 0 0-.028 2.094l-.004.01A1.5 1.5 0 0 0 0 5.624v.75a1.5 1.5 0 0 0 1.474 1.5 1.5 1.5 0 0 0 .018 2.102l.53.53a1.5 1.5 0 0 0 2.104.019A1.5 1.5 0 0 0 5.626 12h.75a1.5 1.5 0 0 0 1.5-1.474 1.5 1.5 0 0 0 2.102-.018l.53-.53a1.5 1.5 0 0 0 .018-2.103A1.5 1.5 0 0 0 12 6.375v-.75a1.5 1.5 0 0 0-1.474-1.5 1.5 1.5 0 0 0-.018-2.102l-.53-.53a1.5 1.5 0 0 0-2.103-.02A1.5 1.5 0 0 0 6.375 0zm-.5 1.5a.5.5 0 0 1 .5-.5h.75a.5.5 0 0 1 .5.5v.322a.5.5 0 0 0 .341.475q.278.092.535.225a.5.5 0 0 0 .581-.092l.231-.23a.5.5 0 0 1 .707 0l.346-.346-.346.345.53.53a.5.5 0 0 1 0 .708l-.242.243a.5.5 0 0 0-.095.576q.126.252.214.524a.5.5 0 0 0 .476.345h.347a.5.5 0 0 1 .5.5v.75a.5.5 0 0 1-.5.5h-.36a.5.5 0 0 0-.474.341q-.089.265-.214.513a.5.5 0 0 0 .093.578l.256.256a.5.5 0 0 1 0 .707l-.53.53a.5.5 0 0 1-.708 0l-.255-.255a.5.5 0 0 0-.58-.093 4 4 0 0 1-.512.214.5.5 0 0 0-.34.474v.36a.5.5 0 0 1-.5.5h-.75a.5.5 0 0 1-.5-.5v-.348a.5.5 0 0 0-.346-.475 4 4 0 0 1-.524-.214.5.5 0 0 0-.576.094l-.243.244a.5.5 0 0 1-.707 0l-.53-.53-.354.353.353-.354a.5.5 0 0 1 0-.707l.231-.23a.5.5 0 0 0 .092-.582 4 4 0 0 1-.225-.535.5.5 0 0 0-.474-.341H1.5a.5.5 0 0 1-.5-.5v-.75a.5.5 0 0 1 .5-.5h.31a.5.5 0 0 0 .476-.345q.091-.284.225-.546a.5.5 0 0 0-.093-.58L2.2 3.438a.5.5 0 0 1 0-.707l.53-.53a.5.5 0 0 1 .707 0l.218.218a.5.5 0 0 0 .579.092q.263-.132.546-.225a.5.5 0 0 0 .345-.475zm2.218 4.518a1.325 1.325 0 1 1-2.65 0 1.325 1.325 0 0 1 2.65 0m1 0a2.325 2.325 0 1 1-4.65 0 2.325 2.325 0 0 1 4.65 0"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Cog12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconCog12);
